import styled from "@emotion/styled";

export const Item = styled.li`
  padding: 9px 14px;

  background-color: ${({ active, theme }) =>
    active ? theme.colors.black : ""};

  font-size: 16px;
  font-weight: ${p => p.theme.fontWeight.medium};
  color: ${({ active, theme }) =>
    active ? theme.colors.white : theme.colors.secondary.main};

  border-radius: 30px;
  cursor: ${({ active }) => (active ? "default" : "pointer")};
  transition: background-color 0.3s ease-in-out;

  -webkit-tap-highlight-color: transparent;

  :hover {
    background-color: ${({ active, theme }) =>
      active ? theme.colors.black : theme.colors.secondary.scroll};
  }

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    padding: 18px 24px;

    font-size: ${p => p.theme.fontSizes.m};
  }
`;
